// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioImage-VeloRadioLabel_cls1__dak8T","cls2":"VeloRadioImage-VeloRadioLabel_cls2__GH8X+ VeloRadioImage-VeloRadioLabel_cls1__dak8T"};